import * as actionTypes from "./actionTypes";
import initialState from "../../reducers/initialState";

export default function logsReducer(state = initialState.logsData, action) {
  switch (action.type) {
    case actionTypes.LOAD_LOGS_STARTED: {
      return {
        ...state,
        searching: true
      };
    }

    case actionTypes.LOAD_LOGS_SUCCEEDED: {
      return {
        ...state,
        logs: action.payload.logs,
        searching: false
      };
    }

    case actionTypes.LOAD_DOWNLOADPATH_SUCCEEDED: {
      return {
        ...state,
        downloadLink: action.payload.downloadLink
      };
    }

    case actionTypes.LOAD_LEVELS_SUCCEEDED: {
      return {
        ...state,
        levels: action.payload.levels
      };
    }

    case actionTypes.LOAD_LOG_SUCCEEDED: {
      return {
        ...state,
        currentLog: action.payload.log
      };
    }

    default:
      return state;
  }
}
